<template>
  <div class="flex justify-between">
    <div class="individual-card" v-for="(visa, i) in visas" :key="i">
      <div class="inner">
        <h2>
          {{ visa.title }}
        </h2>
        <p>
          {{ visa.content }}
        </p>
        <div class="button flex">
          Click here
          <img src="/images/icons/right-main.svg" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visas: [
        {
          title: "Work visas",
          content:
            "Torquem detraxit hosti et quidem se oratio, tua praesertim, qui studiose antiqua persequeris claris et rationibus.",
        },
        {
          title: "Resident visas",
          content:
            "Torquem detraxit hosti et quidem se oratio, tua praesertim, qui studiose antiqua persequeris claris et rationibus.",
        },
        {
          title: "Student visas",
          content:
            "Torquem detraxit hosti et quidem se oratio, tua praesertim, qui studiose antiqua persequeris claris et rationibus.",
        },
        {
          title: "Family visas",
          content:
            "Torquem detraxit hosti et quidem se oratio, tua praesertim, qui studiose antiqua persequeris claris et rationibus.",
        },
        {
          title: "Visitor visas",
          content:
            "Torquem detraxit hosti et quidem se oratio, tua praesertim, qui studiose antiqua persequeris claris et rationibus.",
        },
        {
          title: "Business & investor visas",
          content:
            "Torquem detraxit hosti et quidem se oratio, tua praesertim, qui studiose antiqua persequeris claris et rationibus.",
        },
        {
          title: "Immigration complications",
          content:
            "Torquem detraxit hosti et quidem se oratio, tua praesertim, qui studiose antiqua persequeris claris et rationibus.",
        },
      ],
    };
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/utils/IndividualCard.vue